import * as React from 'react'
import {
  withStyles,
  WithStyles,
  Checkbox,
  CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
  CheckBoxIcon,
} from '@zn-material-ui'
import agrForLoginStyles from './styles/AgrForLoginStyles'

interface IProps extends WithStyles<typeof agrForLoginStyles> {
  handleAgree: (e: any, val: boolean) => void
  checkAgreement: boolean
}

const AgrForLogin: React.SFC<IProps> = ({ classes, handleAgree }) => (
  <div className={classes.checkboxCon}>
    <Checkbox
      icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
      checkedIcon={<CheckBoxIcon fontSize="small" />}
      onChange={handleAgree}
      value="rememberPwd"
      color="primary"
    />
    <span>
      我已阅读并同意
      <a href="/znWeb/znPortal/#/agreement/privacy" target="_blank" className={classes.link}>《隐私政策》</a>
    </span>
  </div>
)

export default withStyles(agrForLoginStyles)(AgrForLogin)
